module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Cambiar contraseña a: " + _vm._s(this.user))])]), _vm._v(" "), _c('emt-form', {
    ref: "reassignment-form",
    attrs: {
      "items": _vm.itemsFormActivityReassignment,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-740d6b46"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-change-password.vue
// module id = 203
// module chunks = 0